'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import type { Member } from '../../types/member';

export function MemberCard({ member }: { member: Member }) {
  return (
    <div className="flex w-full flex-col items-start justify-start gap-4">
      <Image
        src={member?.image?.url ?? '/images/placeholder.png'}
        alt={resolveImageAlt(member?.image, [member.name, member.surname].filter(Boolean).join(' '))}
        width={0}
        height={0}
        className="aspect-square w-full object-cover object-center"
        sizes="100vw"
      />
      <div className="flex w-full flex-col items-start justify-start gap-1">
        <div className="flex items-center justify-start gap-3">
          <h3 data-ea-visual-tag="h6" className="text-lg font-bold sm:text-xl">
            {member.name} {member.surname}
          </h3>
          <div className="flex items-center justify-start gap-1.5">
            {!!member.languages &&
              member.languages.map(lang => (
                <Image
                  key={lang.id}
                  src={lang.image?.url ?? '/images/placeholder.png'}
                  alt={resolveImageAlt(lang?.image, lang?.name)}
                  width={0}
                  height={0}
                  className="h-4 w-auto object-contain object-center"
                />
              ))}
          </div>
        </div>

        <p className="text-sm font-semibold text-muted-foreground lg:text-base">{member.role}</p>
        {member.email && (
          <Link
            prefetch={false}
            target="_blank"
            href={`mailto:${member.email}`}
            className="text-sm text-primary lg:text-base"
          >
            {member.email}
          </Link>
        )}
        {member.phone && (
          <Link
            prefetch={false}
            target="_blank"
            href={`mailto:${member.phone}`}
            className="text-sm text-primary lg:text-base"
          >
            {member.phone}
          </Link>
        )}
      </div>
    </div>
  );
}
